import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import ProductCard from "@/components/ProductCard";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Products() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const category = params.get("category") || "";

  useEffect(() => {
    axios.get(`${API}/products/categories`).then((r) => setCategories(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const q = new URLSearchParams();
    if (category) q.set("category", category);
    if (search) q.set("search", search);
    axios.get(`${API}/products?${q.toString()}`)
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [category, search]);

  const setCategory = (c) => {
    if (c) params.set("category", c);
    else params.delete("category");
    setParams(params);
  };

  return (
    <div className="container-app px-6 md:px-10 py-10">
      <div className="mb-8">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-[#1A1A1A]">
          {category || "All medical supplies"}
        </h1>
        <p className="text-[#595959] mt-2">{products.length} products</p>
      </div>

      <div className="grid lg:grid-cols-[240px_1fr] gap-8">
        <aside className="space-y-6">
          <div>
            <div className="relative">
              <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"/>
              <Input data-testid="search-input" placeholder="Search products"
                     value={search} onChange={(e) => setSearch(e.target.value)}
                     className="pl-9 bg-white rounded-lg"/>
            </div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider text-[#595959] font-semibold mb-3">Categories</div>
            <ul className="space-y-1">
              <li>
                <button data-testid="filter-all"
                        onClick={() => setCategory("")}
                        className={`w-full text-left px-3 py-2 rounded-lg text-sm ${!category ? "bg-[#638971] text-white" : "hover:bg-white text-[#2C4035]"}`}>
                  All
                </button>
              </li>
              {categories.map((c) => (
                <li key={c}>
                  <button data-testid={`filter-${c.toLowerCase().replace(' ', '-')}`}
                          onClick={() => setCategory(c)}
                          className={`w-full text-left px-3 py-2 rounded-lg text-sm ${category === c ? "bg-[#638971] text-white" : "hover:bg-white text-[#2C4035]"}`}>
                    {c}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </aside>

        <div>
          {loading ? (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="rounded-xl bg-white border border-gray-100 aspect-[3/4] animate-pulse"/>
              ))}
            </div>
          ) : products.length === 0 ? (
            <div data-testid="no-products" className="text-center py-20 text-[#595959]">No products found.</div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
              {products.map((p) => <ProductCard key={p.id} product={p}/>)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
